
const TYPE_ERROR = 'danger';
const TYPE_SUCCESS = 'success';
const TYPE_WARNING = 'warning';
const TYPE_INFO = 'info';

const selectorPrefix = '.js-error-container';
const showDelay = 7000;
const classes = [
	'label-danger',
	'label-warning',
	'label-success'
];
let hideTimeout =  false;
let errorStack = [];
let errorContainer = null;

export default {
	showMessage(text, type, woDelay, woTimeout) {
		if (!errorContainer) {
			errorContainer = document.querySelector(selectorPrefix);
			errorContainer.querySelector(selectorPrefix + '-close').addEventListener('click', () =>  {
				this.hideMessage();
				return false;
			});
		}

		if (!type) type = TYPE_ERROR;

		woTimeout = woTimeout || false;

		this.hideMessage();

		const err = new Error();

		errorStack.push({
			'text': text,
			'type': type,
			'stack': err.stack
		});

		//TODO:: анимацию прикрутить
		let textNode = errorContainer.querySelector(selectorPrefix + '-text');
		textNode.innerHTML = text;
		errorContainer.style.display = 'block';
		classes.forEach((cssClass) => {
			errorContainer.classList.remove(cssClass);
		});
		errorContainer.classList.add('label-' + type);

		if (showDelay && !woDelay) {
			if (hideTimeout) {
				clearTimeout(hideTimeout);
			}

			if (!woTimeout) {
				hideTimeout = setTimeout(() => {
					this.hideMessage();
				}, showDelay);
			}
		}

		if (type === TYPE_ERROR) {
			this.log(text, err.stack);
		}
	},

	hideMessage () {
		if (errorContainer && errorContainer.offsetHeight > 0)
			errorContainer.style.display = 'none';
		//this.$getModalErrorBlock(true).hide();
	},

	showError(message, woDelay, woTimeout) {
		this.showMessage(message,TYPE_ERROR, woDelay, woTimeout)
	},

 	showSuccess(message, woDelay, woTimeout) {
		this.showMessage(message, TYPE_SUCCESS, woDelay, woTimeout)
	},

	showWarning(message, woDelay, woTimeout){
		this.showMessage(message, TYPE_WARNING, woDelay, woTimeout)
	},

	showInfo(message, woDelay, woTimeout) {
		this.showMessage(message, TYPE_INFO, woDelay, woTimeout)
	},

	log(text, stack, context) {
		context = context || {};
		fetch('/ajax_new/jsLogger.php', {
		    method: 'POST',
		    body: JSON.stringify({
				text: text,
				stack: stack,
				context: context
			}),
		    headers: {
		        'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
		});
	}
}